import logEvent from 'analytics/logEvent';
import cn from 'classnames';
import { UrlService } from 'domains/common/url';
import { useRouter } from 'next/router';
import React from 'react';

import ALink from 'components/basic/ALink';
import Icon, { IconTypes } from 'components/basic/Icon';
import DesktopMenu from 'components/layouts/Header/DesktopMenu';

import { useAppDispatch } from 'redux-store';
import { openModal } from 'redux-store/slices/ui';

import Logo from './img/logo.svg';

import s from './Header.module.scss';

interface Props {
  className?: string;
  hideLink?: boolean;
  withoutLogo?: boolean;
}

// Absolute app URL: some pages (e.g. /plans) are also served under welltory.com,
// where relative app paths are not proxied and client navigation fails.
const urlAppService = new UrlService({ main: false });

const Header: React.FC<Props> = ({ hideLink, className, withoutLogo }) => {
  const dispatch = useAppDispatch();
  const router = useRouter();
  const isCompact = !!router.query.compact;

  let logo = <div />;

  if (!withoutLogo) {
    logo =
      hideLink || isCompact ? (
        <Logo />
      ) : (
        <ALink href={urlAppService.getUrl('/')} className={s.logoLink}>
          <Logo />
        </ALink>
      );
  }

  return (
    <header className={cn(s.wrapper, className)}>
      {logo}

      {isCompact ? null : (
        <Icon
          icon={IconTypes.burger}
          color="white"
          size={24}
          onClick={(): void => {
            logEvent('Web_Header_Menu_Button_Clicked');
            dispatch(openModal({ type: 'MobileMenu' }));
          }}
          className={cn(s.mobileMenuButton, 'cy-mobile-profile-menu')}
        />
      )}

      <DesktopMenu />
    </header>
  );
};

export default Header;
